import {defineStore} from 'pinia'

export const useGlobalSearchStore = defineStore('globalSearch', {
    state: () => ({
        searchInput: null,
        currentModule: null,
        connected: null,
    }),

    actions: {
        setCurrentModule(currentModule) {
            this.currentModule = currentModule
        },
        setSearchInput(searchInput) {
            this.searchInput = searchInput
        },
        connect(tableModule) {
            this.connected = tableModule
        },
        disconnect() {
            this.connected = null
        }
    },
})
